import parseISO from 'date-fns/parseISO';
import differenceInDays from 'date-fns/differenceInDays';
import startOfToday from 'date-fns/startOfToday';
import dayjs from 'dayjs';
import formatISO from 'date-fns/formatISO';

const validatePrepopulationOptions = (prepopulationValues, options) => {
  let isValid = true;
  let validValues = [];
  prepopulationValues.forEach((value) => {
    if (options.findIndex((e) => e.value === value) === -1) {
      isValid = false;
    } else {
      validValues.push(value);
    }
  });
  return {
    isValid,
    validValues: isValid
      ? [...prepopulationValues]
      : validValues.length === 0
      ? undefined
      : [...validValues]
  };
};

const validateFilters = (filters, prePopulation, panel) => {
  let newPrepopulation = { ...prePopulation };
  filters.forEach((filterConfiguration) => {
    if (
      filterConfiguration?.type &&
      filterConfiguration?.id &&
      filterConfiguration?.options &&
      newPrepopulation?.filters &&
      panel?.id &&
      filterConfiguration?.type === 'multi-select'
    ) {
      const prepopulationValues = newPrepopulation?.filters[panel?.id][filterConfiguration?.id];
      const options = filterConfiguration?.options;
      if (
        options &&
        prepopulationValues &&
        Array.isArray(prepopulationValues) &&
        Array.isArray(options)
      ) {
        const { isValid, validValues } = validatePrepopulationOptions(prepopulationValues, options);
        if (!isValid) {
          newPrepopulation = {
            ...newPrepopulation,
            filters: {
              ...newPrepopulation?.filters,
              [panel?.id]: {
                ...newPrepopulation?.filters[panel?.id],
                [filterConfiguration?.id]: validValues ? [...validValues] : validValues
              }
            }
          };
        }
      }
    } else if (filterConfiguration?.type === 'date-range' && panel?.id && filterConfiguration?.id) {
      const prepopulatedValue = newPrepopulation?.filters[panel?.id][filterConfiguration?.id];

      if (prepopulatedValue) {
        const eventStartDate = filterConfiguration?.startDate
          ? parseISO(filterConfiguration?.startDate)
          : new Date(2023, 0, 16);

        const departure = filterConfiguration?.departure
          ? { ...filterConfiguration?.departure }
          : {
              start: differenceInDays(eventStartDate, startOfToday()),
              end: 14
            };

        const availableDays = filterConfiguration?.availableDays
          ? filterConfiguration?.availableDays
          : 45;

        const startDate =
          departure && departure.start
            ? dayjs(new Date()).add(departure.start, 'day').toDate()
            : new Date();

        const availableDays_ = departure ? departure.start + departure.end : availableDays;

        const endDate =
          departure && departure.end && departure.start
            ? dayjs(new Date())
                .add(departure.end + departure.start - 1, 'day')
                .toDate()
            : dayjs(new Date())
                .add(availableDays_ - 1, 'day')
                .toDate();

        const startDateBase = dayjs(startDate).add(-1, 'day').toDate();

        const newPrepopulatedValue = [];

        prepopulatedValue.forEach((day) => {
          if (day >= 1) {
            const tmpDate = dayjs(startDateBase).add(day, 'day').toDate();
            if (
              (dayjs(tmpDate).isSame(startDate, 'day') ||
                dayjs(tmpDate).isSame(endDate, 'day') ||
                (dayjs(tmpDate).isAfter(startDate, 'day') &&
                  dayjs(tmpDate).isBefore(endDate, 'day'))) &&
              dayjs(startDate).get('month') === dayjs(tmpDate).get('month')
            ) {
              newPrepopulatedValue.push(formatISO(tmpDate, { representation: 'date' }));
            }
          }
        });
        newPrepopulation = {
          ...newPrepopulation,
          filters: {
            ...newPrepopulation?.filters,
            [panel?.id]: {
              ...newPrepopulation?.filters[panel?.id],
              [filterConfiguration?.id]: newPrepopulatedValue
                ? [...newPrepopulatedValue]
                : undefined
            }
          }
        };
      }
    }
  });
  return newPrepopulation;
};

const validatePrepopulationData = ({ prePopulation, componentsConfiguration }) => {
  let newPrepopulation = { ...prePopulation };
  if (
    componentsConfiguration &&
    componentsConfiguration?.filterContainer &&
    componentsConfiguration?.filterContainer?.panels &&
    prePopulation?.filters
  ) {
    const panels = componentsConfiguration?.filterContainer?.panels;
    panels.forEach((panel) => {
      if (panel?.filters) {
        const filters = panel?.filters;
        newPrepopulation = { ...validateFilters(filters, newPrepopulation, panel) };
      }
      if (panel?.secondaryFilters) {
        const secondaryFilters = panel?.secondaryFilters;
        newPrepopulation = { ...validateFilters(secondaryFilters, newPrepopulation, panel) };
      }
    });
  }
  return newPrepopulation;
};

export { validatePrepopulationData };
